






import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import * as ace from 'brace';
import { Editor } from 'brace';
import 'brace/mode/javascript';
import 'brace/mode/html';
import 'brace/theme/xcode';

@Component
export default class CodeEditor extends Vue {
    @Prop()
    id!: string;

    @Prop({ default: '' })
    value!: string;

    @Prop({ default: 'ace/mode/javascript' })
    mode!: string;

    @Prop({ default: 0 })
    maxLength!: number;

    editor: Editor | null = null;

    editRefreshTimeout: number | null = null;

    mounted() {
      this.id = this.id;
      this.editor = ace.edit(this.id);
      this.editor.getSession().setMode(this.mode);
      this.editor.setTheme('ace/theme/xcode');

      this.editor.$blockScrolling = Infinity;

      this.editor.setOptions({
        printMargin: false,
      });

      this.editor.setValue(this.value, -1);


      this.editor.on('change', () => {
        if (this.maxLength > 0 && this.editor!.getValue().length > this.maxLength) {
          this.editor!.setValue(this.editor!.getValue().substring(0, this.maxLength), 1);
        }

        if (this.editRefreshTimeout !== null) {
          clearTimeout(this.editRefreshTimeout);
        }

        this.editRefreshTimeout = setTimeout(() => { this.$emit('input', this.editor!.getValue()); this.editRefreshTimeout = null; }, 500);
      });
    }


    @Watch('value')
    onValueChange() {
      if (this.maxLength > 0 && this.value.length > this.maxLength) {
        this.value = this.value.substring(0, this.maxLength);
      }

      if (this.editor!.getValue() !== this.value) {
        this.editor?.setValue(this.value, -1);
      }
    }
}
